import { Segment } from "../types/segments";

interface Action {
	type: string;
	payload: any;
}

export const SET_SEGMENTS = 'SET_SEGMENTS';
export function setSegments(segments: Segment[]): Action {
	return {
		type: SET_SEGMENTS,
		payload: segments,
	};
}

export const SET_DISTRIBUTED_SHOT_DURATIONS = 'SET_DISTRIBUTED_SHOT_DURATIONS';
export function setDistributedShotDurations(durations: Record<string, number>): Action {
	return {
		type: SET_DISTRIBUTED_SHOT_DURATIONS,
		payload: durations,
	};
}
